module.exports = __webpack_public_path__ + "img/freespin2.ca4866d2.png";